import './Me.css';

const Me = () => (
  <div id="Me">
    <h2>Hi, I'm Sophie. Nice to meet you 👋</h2>
    <div>
      <a href="https://www.instagram.com/mccarrellsophie/">Fashion 💃</a> - 
      <a href="https://www.instagram.com/hangin_w_sophie/">Exploration 🏕️</a> - 
      <a href="https://www.instagram.com/gottahavemytimmies/">Coffee ☕️</a>
    </div>
    <img className="Me-mugshot" src="mugshot.jpg" alt="Sophie from 2021" />
    <p>
      👩‍💻 I'm a computer scientist and a queer woman. 🏳️‍🌈<br />
      👩‍🍳 I'm a helper and anti-imperialist. 🚩<br />
      🔨 I love to make things, especially games. 🎮<br />
      I volunteer at the Ottawa Trans Library and I work as a crossing gaurd.<br />
      I also make Vegan and gluten free desserts, like nainamo bars.<br />
      You'll often find me bicycling around Ottawa 🚲<br />
    </p>
  </div>
);

export default Me;
